import { render, staticRenderFns } from "./googleform.vue?vue&type=template&id=549b7fcc&scoped=true"
import script from "./googleform.vue?vue&type=script&lang=js"
export * from "./googleform.vue?vue&type=script&lang=js"
import style0 from "./googleform.vue?vue&type=style&index=0&id=549b7fcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549b7fcc",
  null
  
)

export default component.exports